import React, { useEffect, useState } from "react";
import { NavigateFunction, useNavigate } from 'react-router-dom';
import './Tables.css';
import {
  Box,
  Button,
  FormControlLabel,
  List,
  ListItem,
  Stack,
  Typography
} from '@mui/material';
import { useInfoStore } from "../../store/userInfo";
// import { useQuery } from "@tanstack/react-query";
import _ from "lodash";
import { logger } from "../../utils/logger";
import { ITables } from "../../types/store";
import { black, grey, primary } from "../../theme/colors";
import { isBrowser } from 'react-device-detect';
import { IOSSwitch } from "../../components/switch";
// import Loading from "../../components/Loading";
import { useWindowDimensions } from "../../App";
import { getTables } from "../../services/setting.service";
// import { checkIfAnyDataExists, fetchImageAsBlob } from "../../components/IndexedDB";
import { getAllMenuImage } from "../../services/menu.service";
// import { useMenuCache } from "../../store/menuCache";

type Props = {}
const IMAGE_URL = process.env.REACT_APP_S3_IMAGE_PAPH;
const Tables: React.FC<Props> = () => {
  const { userInfo, tableInfo, orderBook, loginMode, setTableInfo, setOrderBook, setLoginMode } = useInfoStore();
  // const { setMenuCache } = useMenuCache();
  const { height } = useWindowDimensions();
  const storeId = userInfo?.storeId;
  const navigate: NavigateFunction = useNavigate();
  const [tables, setTables] = useState([])
  const [selectedTable, setSelectedTable] = useState<ITables|null>(null);

  // const version = process.env.REACT_APP_VERSION
  useEffect(() => {
    loadTables()
  }, [])

  const loadData = async () => {
    // const cacheExist = await checkIfAnyDataExists()
    // console.log("loadData", cacheExist)
    // if(cacheExist) {
      loadTables()
    // } else {
    //   console.log('getall');
    //   const res = await getAllMenuImage(storeId!);
    //   const data = res.data;
    //   await Promise.all(
    //     data.map(async (item: any) => {
    //       if (!item.images[0]) return;
      
    //       const imageUrl = `${IMAGE_URL}/${item.images[0]}`;
    //       // console.log('loadData!!!!', imageUrl)
    //       const blob = await fetchImageAsBlob(imageUrl); // ✅ Blob 가져오기
    //       if (!blob) return;
      
    //       setMenuCache(item.images[0], blob); // ✅ Blob 저장
    //     })
    //   );
    //   loadTables()
    // }
  }

  const loadTables = async () => {
    await getTables(storeId!).then(
      async res => {
        setTables(res.data)
        if(tableInfo.id) {
          setSelectedTable(tableInfo)
          logger.debug(loginMode)
          if(_.isEqual(loginMode,"quick")) {
            setLoginMode('normal')
            if(!isBrowser){
              if(window.ReactNativeWebView !== undefined)
                window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'tableInfo', 'data': tableInfo}));
              else if(window.Android !== undefined)
                window.Android.postMessage(JSON.stringify({'type': 'tableInfo', 'data': tableInfo}));
            }
            if(userInfo?.isAyce) {
              navigate('/aycemenu')
            } else
              navigate('/main');
          } else if(_.isEqual(loginMode,"qr")) {
            if(!isBrowser){
              if(window.ReactNativeWebView !== undefined)
                window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'tableInfo', 'data': tableInfo}));
              else if(window.Android !== undefined)
                window.Android.postMessage(JSON.stringify({'type': 'tableInfo', 'data': tableInfo}));
            }
            if(userInfo?.isAyce) {
              navigate('/aycemenu')
            } else
              navigate('/main');
          }          
        }
      }
    )
  }

  const handleSelectTable = (item: ITables) => {
    setSelectedTable(item)
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
  };

  const checkSelectTable = (item: ITables) => {
    if(!selectedTable) return false
    return _.isEqual(item.id,selectedTable!.id) ? true: false
  }

  const handleOrderBook = (event: React.ChangeEvent<HTMLInputElement>) => {
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    setOrderBook(event.target.checked)
  }

  const handleCancel = () => {
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    if(tableInfo){
      if(userInfo?.isAyce) {
        navigate('/aycemenu')
      } else
        navigate('/main')
    }
  }

  const handleSave = () => {
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    if(selectedTable) {
      setTableInfo(selectedTable)
    } else {
      return;
    }
    if(!isBrowser){
      if(window.ReactNativeWebView !== undefined)
        window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'tableInfo', 'data': selectedTable}));
      else if(window.Android !== undefined)
        window.Android.postMessage(JSON.stringify({'type': 'tableInfo', 'data': selectedTable}));
    }
    if(userInfo?.isAyce) {
      navigate('/aycemenu')
    } else 
      navigate('/main')
  }

  return (
      <Box 
        sx={{
          backgroundColor: 'background.paper',
          justifyContent: 'center',
          alignItems: 'flex-start',
          width: '100vw',
          height: height,
          mx: '1rem'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            mt: '4.2rem',
            px: '2rem',
            justifyContent: 'space-between'
          }}
        >
          <Stack
            spacing={1}
            sx={{ height: '7.8rem', width: '50%', justifyContent: 'center', alignItems: 'flex-start' }}
          >
            <p className="header" >Assign new table </p>
            <p className="sub-header">This action will change table number only</p>
          </Stack>
          <FormControlLabel
            control={<IOSSwitch
              color="primary"
              checked={orderBook}
              onChange={handleOrderBook}
            />}  label={<Typography sx={{mr: '0.5rem', fontSize: '2rem', fontStyle: 'normal', fontWeight: '600'}}>Order book</Typography>} labelPlacement="start"/>
        </Box>
        <Box className="table-box" sx={{ width: '100%', backgroundColor: '#F4F4F4', mt: '1.8rem', minHeight: '55rem', height: `60%` }}>
          <List style={{ overflow: "overlay", overflowX: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap'}}>
              {tables.length !==0 && tables.map((item: ITables, index: number) => {
                return(
                  <ListItem key={index} sx={[{  m: '1.2rem', borderRadius: '6.0rem', width: "auto", minWidth: '6rem', height: '6rem', display: 'inline-flex',justifyContent: 'center', alignItems: 'center', px: '1.8rem', whiteSpace: "normal"},
                    checkSelectTable(item) ? {backgroundColor: primary.main}: item.isKioskMode?{backgroundColor: '#000'} : {backgroundColor: '#fff'}]} onClick={() => handleSelectTable(item)}>
                    <Typography sx={[checkSelectTable(item)|| item.isKioskMode ? {color: '#fff', fontWeight: '600', fontSize: '2rem', lineHeight: 'normal'}: {color: black.main, fontSize: '2rem'},
                    { textAlign: 'center', alignItems: 'center',  textTransform: 'none', whiteSpace : 'nowrap', flex: '0 0 auto'}]}>{item.tableName}</Typography>
                  </ListItem>)
                })}
          </List>
          {/* {tables.length ===0 && <Box sx={{width: '100vw'}}><Typography sx={{textAlign: 'center'}}>... Creating Cache ...</Typography></Box> } */}
        </Box>
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', mb: '4.6rem', mt: '2rem'}}>
          { tableInfo.id !== undefined ? <Button
            id={'table-cancel'}
            size="large"
            sx={{  width: '15.5rem', borderRadius: '6rem', height: '6rem', textTransform: 'none', backgroundColor: grey.main , color: 'black', fontSize: '2rem' }}
            fullWidth
            type="button"
            variant="contained"
            onClick={() => handleCancel()}
          >
            Cancel
          </Button> :<></>}
          <Button
            id={'table-save'}
            size="large"
            sx={{  ml: '2.4rem', width: '15.5rem', borderRadius: '6rem', height: '6rem', backgroundColor: 'black', textTransform: 'none', fontSize: '2rem' }}
            fullWidth
            type="button"
            variant="contained"
            onClick={() => handleSave()}
          >
            Save
          </Button>
        </Box>
        {/* <Typography sx={{position: 'absolute', bottom: '5rem', right: '5rem', color: '#f5f5f5'}}>{version}</Typography> */}
      </Box>
  );
}

export default Tables;

